import { get } from '../utils/network';
import config from './config';
import mime from 'mime-types';
import Swal from 'sweetalert2';


export const fetchImage = async (fileSource) => {
    try {
      const response = await get(fileSource);
      // TODO: Usar network.js
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      return url;
    } catch (error) {
      console.error('Failed to fetch image', error);
    }
  };

export function downloadFile(name) {
  console.log("Downloading document: ", name);

  return get(`documents/${name}/file`)
      .then((response) => {
          if (!response.ok) {
              Swal.fire({
                  title: 'Error',
                  text: `No se pudo descargar el archivo ${name}.`,
                  icon: 'error',
              });
              throw new Error(`Failed to fetch file ${name}`);
          }
          return response.blob(); // Convert response to a Blob
      })
      .then((blob) => {
          // Use mime-types to get the extension
          const mimeType = blob.type;
          const extension = mime.extension(mimeType) || ''; // Get extension or fallback to empty string

          const fullFilename = extension ? `${name}.${extension}` : name;
          const link = document.createElement('a');
          const blobUrl = window.URL.createObjectURL(blob);

          link.href = blobUrl;
          link.download = fullFilename;

          document.body.appendChild(link);
          link.click();

          document.body.removeChild(link);
          window.URL.revokeObjectURL(blobUrl);
      })
      .catch((error) => {
          console.error("Error in downloading the file: ", error);
          throw error;
      });
}

export function downloadDocumentTypesJsonFile(url, filename) {
  return new Promise((resolve) => {
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    
    resolve()
  });
}

export function downloadZip(url, filename) {
  return new Promise((resolve) => {
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    
    resolve()
  });
}